import { StateInfo, StoresByState } from '@src/types/strapi/collections/storesByState'

export const mapToStatesInfos = (storesByStates?: StoresByState[]): StateInfo[] =>
  storesByStates?.map(({ initials, name }) => ({ initials, name })) || []
